import { sessaoFetchLoading, sessaoFetchLoadingUpload } from '@/service/fetch'

export async function add (dados) {
  return sessaoFetchLoadingUpload(`base`, `/arquivo/${dados.tipo}`, 'POST', dados.arquivo)
}

export async function del (arquivo) {
  return sessaoFetchLoading(`base`, `/arquivo/${arquivo}`, 'DELETE')
}



// WEBPACK FOOTER //
// ./src/api/arquivo.js